module.exports = __webpack_public_path__ + "media/images/icons/logo-0766f5ac913df1b214da553a55267b3f.svg";